import { AppLayout, ViewLayout } from '@/components/Layout'

const otherRoutes = [
  {
    // 头部导航
    path: '/index',
    name: 'index',
    component: () => import('@/views/auth/index')
  },
  {
    // 网站首页
    path: '/HomePage',
    name: 'Homepage',
    component: () => import('@/views/auth/HomePage')
  },
  {
    // 研究领域
    path: '/researchField',
    name: 'researchField',
    component: () => import('@/views/auth/researchField')
  },
  {
    // 新资讯
    path: '/newInformation',
    name: 'newInformation',
    component: () => import('@/views/auth/newInformation')
  },
  {
    // 头条推荐
    path: '/headlineRecommendation',
    name: 'headlineRecommendation',
    component: () => import('@/views/auth/headlineRecommendation')
  },
  {
    // EDP班
    path: '/edp',
    name: 'edp',
    component: () => import('@/views/auth/edp')
  },
  {
    // 低碳生活
    path: '/lowCarbonLife',
    name: 'lowCarbonLife',
    component: () => import('@/views/auth/lowCarbonLife')
  },
  {
    // 地球牧歌俱乐部
    path: '/earthMuGe',
    name: 'earthMuGe',
    component: () => import('@/views/auth/earthMuGe')
  },
  {
    // 平台伙伴
    path: '/platformPartners',
    name: 'platformPartners',
    component: () => import('@/views/auth/platformPartners')
  },
  {
    // 专家达人
    path: '/expert',
    name: 'expert',
    component: () => import('@/views/auth/expert')
  },
  {
    // 文本内容
    path: '/textContent',
    name: 'textContent',
    component: () => import('@/views/auth/textContent')
  },
  {
    // 文本内容
    path: '/textTwoContent',
    name: 'textTwoContent',
    component: () => import('@/views/auth/textTwoContent')
  },
  {
    // 文本内容
    path: '/selectContent',
    name: 'selectContent',
    component: () => import('@/views/auth/selectContent')
  },
  {
    // 插入尾部
    path: '/footer',
    name: 'footer',
    component: () => import('@/views/auth/footer')
  },
  {
    path: '/error',
    name: 'error',
    redirect: '404',
    component: ViewLayout,
    children: [
      {
        path: '404',
        name: '404',
        component: () => import(/* webpackChunkName: "404" */ '@/views/error/404')
      }
    ]
  }
]

export const appRoutes = [
  {
    path: '/',
    name: 'index',
    redirect: '/dashboard/analysis',
    component: AppLayout,
    children: [
      {
        path: 'table',
        name: 'table',
        meta: {
          title: '表格页',
          icon: 'table'
        },
        component: () => import(/* webpackChunkName: "table" */ '@/views/table/table')
      },
      {
        path: 'dashboard',
        name: 'dashboard',
        meta: {
          title: 'Dashboard',
          icon: 'dashboard'
        },
        component: ViewLayout,
        children: [
          {
            path: 'analysis',
            name: 'dashboard_analysis',
            meta: {
              title: '分析页'
            },
            component: () => import(/* webpackChunkName: "analysis" */ '@/views/dashboard/analysis')
          },
          {
            path: 'monitor',
            name: 'dashboard_monitor',
            meta: {
              title: '监控页'
            },
            component: () => import(/* webpackChunkName: "monitor" */ '@/views/dashboard/monitor')
          },
          {
            path: 'v-charts',
            name: 'v-charts',
            meta: {
              title: 'v-charts'
            },
            component: () => import(/* webpackChunkName: "v-charts" */ '@/views/dashboard/vcharts')
          },
          {
            path: 'track',
            name: 'track',
            meta: {
              title: '轨迹图'
            },
            component: () => import(/* webpackChunkName: "track" */ '@/views/dashboard/track')
          }
        ]
      },
      {
        path: 'd3',
        name: 'd3',
        meta: {
          title: 'D3',
          icon: 'stock'
        },
        component: ViewLayout,
        children: [
          {
            path: 'bar',
            name: 'd3_bar',
            meta: {
              title: 'bar'
            },
            component: () => import(/* webpackChunkName: "tutorials" */ '@/views/d3/bar')
          },
          {
            path: 'line',
            name: 'd3_line',
            meta: {
              title: 'line'
            },
            component: () => import(/* webpackChunkName: "tutorials" */ '@/views/d3/line')
          }
        ]
      },
      {
        path: 'g2',
        name: 'g2',
        meta: {
          title: 'g2',
          icon: 'stock'
        },
        component: ViewLayout,
        children: [
          {
            path: 'bar',
            name: 'g2_bar',
            meta: {
              title: 'bar'
            },
            component: () => import(/* webpackChunkName: "tutorials" */ '@/views/g2/bar')
          },
          {
            path: 'line',
            name: 'g2_line',
            meta: {
              title: 'line'
            },
            component: () => import(/* webpackChunkName: "tutorials" */ '@/views/g2/line')
          }
        ]
      }
    ]
  }
]

const routes = [...otherRoutes, ...appRoutes]

export default routes
